import React from "react";

export const SimpleArrowRight = ({ size = 15, fill = "#29394D" }) => (
    <svg
    width="12"
    height="12"
    viewBox="0 0 6 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.08538 3.71446L1.48781 0.118095C1.32995 -0.039365 1.0742 -0.039365 0.91594 0.118095C0.758082 0.275555 0.758082 0.531311 0.91594 0.688771L4.22815 3.99978L0.916339 7.3108C0.75848 7.46826 0.75848 7.72401 0.916339 7.88187C1.0742 8.03933 1.33035 8.03933 1.48821 7.88187L5.08578 4.2855C5.24124 4.12967 5.24124 3.8699 5.08538 3.71446Z"
      fill="#29394D"
    />
  </svg>
);
